import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { updateCourse } from "@redux/actions";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { toast } from "react-toastify";
import { NO_CHANGES_MADE } from "@utils/constants";
import {
  modalStyle,
  modalBody,
  modalHeader,
  styles,
} from "@styles/styledComponents";

class UpdateCourse extends React.Component {
  constructor(props) {
    super(props);
  }
  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  updateForm = async (event) => {
    event.preventDefault();
    if (!this.state) {
      toast(NO_CHANGES_MADE, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark",
        type: "info",
      });
      return;
    }

    const response = await this.props.updateCourse(
      this.state,
      this.props.courseData._id
    );
    const { message, success } = response.data;
    toast(message, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: success ? "success" : "error",
    });
    setTimeout(() => {
      this.props.openModal();
    }, 1000);
  };

  render() {
    const { classes, courseData } = this.props;
    return (
      <>
        <div>
          <Modal
            open={true}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            style={modalStyle}
          >
            <Fade in={true}>
              <Paper elevation={1} variant="normal" square>
                <div style={modalHeader}>
                  <p>Update Leave Status</p>
                </div>
                <div style={modalBody}>
                  <Paper className={classes.paper}>
                    <form
                      className={classes.form}
                      autoComplete="off"
                      onSubmit={this.updateForm}
                    >
                      <TextField
                        id="courses_title"
                        name="courses_title"
                        label="Course Title"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={courseData.courses_title}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="course_link"
                        name="course_link"
                        label="Course Link"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={courseData.course_link}
                        onChange={this.handleChange}
                        margin="normal"
                      />
                      <TextField
                        id="course_desc"
                        name="course_desc"
                        label="Course Desc"
                        fullWidth
                        required
                        className={classes.textField}
                        defaultValue={courseData.course_desc}
                        onChange={this.handleChange}
                        margin="normal"
                      />

                      <br />

                      <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="flex-end"
                      >
                        <Grid item>
                          <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            onClick={this.props.openModal}
                          >
                            Close
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            // onClick={this.updateForm}
                          >
                            Update
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Paper>
                </div>
              </Paper>
            </Fade>
          </Modal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    employees: state.employees?.length && state.employees[0].payload,
  };
};

export default connect(mapStateToProps, { updateCourse })(
  withStyles(styles)(UpdateCourse)
);
